module.exports = __webpack_public_path__ + "assets/img/icon16.221447cc.png";